<template>
  <Card v-if="(flights && flights.length)" title="Flights" margin="">
    <template #actions>
      <button class="btn btn-sm btn-outline-primary" @click="expanded = !expanded">
        {{ expanded ? __DICT__.hide : __DICT__.show }}
      </button>
    </template>
    <div v-if="expanded">
      <div class="d-flex flex-column gap-2">
        <div
          class="card"
          v-for="(f, idx) in flights"
          :key="flightKey(f, idx)"
        >
          <div class="card-body py-3">
            <div class="d-flex align-items-center gap-2">
              <div class="flex-grow-1 me-2">
                <div class="fw-bold">
                  {{ f['Resort'] || '—' }}
                  <span class="text-muted">•</span>
                  <span class="text-muted">{{ __DICT__.week }} {{ f['Week'] || '—' }}</span>
                </div>
                <div class="text-muted small">
                  <span v-if="journeyLabel(f)">{{ journeyLabel(f) }}</span>
                  <span v-if="f['Supplier']"> • {{ f['Supplier'] }}</span>
                </div>
                <div class="text-muted small mt-1" v-if="hasAnyRoute(f)">
                  <template v-if="routeOB(f).from || routeOB(f).to">
                    <span>{{ routeOB(f).from || '—' }}</span>
                    <IconPlane class="mx-1" size="16" />
                    <span>{{ routeOB(f).to || '—' }}</span>
                  </template>
                  <span v-if="(routeOB(f).from || routeOB(f).to) && (routeIB(f).from || routeIB(f).to)" class="text-muted"> • </span>
                  <template v-if="routeIB(f).from || routeIB(f).to">
                    <span>{{ routeIB(f).from || '—' }}</span>
                    <IconPlane class="mx-1" size="16" />
                    <span>{{ routeIB(f).to || '—' }}</span>
                  </template>
                </div>
              </div>

              <div style="width: 100px; text-align: center;">
                <button class="btn mt-2 btn-sm btn-outline-primary" @click="toggle(idx)">
                  {{ rowExpanded[idx] ? __DICT__.hide : __DICT__.details }}
                </button>
              </div>
            </div>

            <div v-if="rowExpanded[idx]" class="mt-3">
              <FlightDetails :flight="f" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script setup>
import { ref } from 'vue'
import FlightDetails from '@/components/FlightDetails.vue'
import { IconPlane } from '@tabler/icons-vue'
import { Card } from "@/components/atomic";

const props = defineProps({
  flights: {
    type: Array,
    default: () => [],
  },
})

const expanded = ref(false)
const rowExpanded = ref({})

function toggle(i) {
  rowExpanded.value[i] = !rowExpanded.value[i]
}

function flightKey(f, idx) {
  return `${f['GBS ID'] || idx}_${f['OB Flight No'] || f['IB Flight No'] || f['Resort'] || 'row'}_${idx}`
}

function journeyLabel(f) {
  const jt = f['Journey type']
  if (jt) return jt
  const hasOB = !!(f['OB Flight No'] || f['OB Route'])
  const hasIB = !!(f['IB Flight No'] || f['IB Route'])
  if (hasOB && hasIB) return 'Return'
  if (hasOB) return 'Outbound only'
  if (hasIB) return 'Inbound only'
  return null
}

function routeParts(route) {
  const s = (route || '').toString().trim()
  if (!s) return { from: null, to: null }
  const byDash = s.split('-').map(x => x.trim()).filter(Boolean)
  if (byDash.length >= 2) return { from: byDash[0], to: byDash[1] }
  const byTo = s.split(/\sto\s/i).map(x => x.trim()).filter(Boolean)
  if (byTo.length >= 2) return { from: byTo[0], to: byTo[1] }
  return { from: null, to: null }
}

function routeOB(f) {
  return routeParts(f && f['OB Route'])
}

function routeIB(f) {
  return routeParts(f && f['IB Route'])
}

function hasAnyRoute(f) {
  const ob = routeOB(f)
  const ib = routeIB(f)
  return !!((ob.from || ob.to || ib.from || ib.to))
}
</script>
